import { useState, useEffect } from "react";
import "./lower-row-button.css";
import { emitKeyDown, emitKeyUp } from "../../../events/piano-events";
import { isPianoPointerDown, setPianoPointerDown } from "../../../events/piano-drag";
import { EVENTS } from "../../../events/events";

export const LowerRowButton = ({ note, octaveNumber, japaneseCharacter }: { note: string, octaveNumber: number, japaneseCharacter: string }) => {

  const constructedNote = `${note}${octaveNumber}`;
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    const onNoteOn = (e: Event) => { if ((e as CustomEvent).detail === constructedNote) setIsActive(true); };
    const onNoteOff = (e: Event) => { if ((e as CustomEvent).detail === constructedNote) setIsActive(false); };
    const onStopped = () => setIsActive(false);
    window.addEventListener(EVENTS.COMPOSER_NOTE_ON, onNoteOn);
    window.addEventListener(EVENTS.COMPOSER_NOTE_OFF, onNoteOff);
    window.addEventListener(EVENTS.COMPOSER_STOPPED, onStopped);
    window.addEventListener(EVENTS.PIANO_KEY_DOWN, onNoteOn);
    window.addEventListener(EVENTS.PIANO_KEY_UP, onNoteOff);
    return () => {
      window.removeEventListener(EVENTS.COMPOSER_NOTE_ON, onNoteOn);
      window.removeEventListener(EVENTS.COMPOSER_NOTE_OFF, onNoteOff);
      window.removeEventListener(EVENTS.COMPOSER_STOPPED, onStopped);
      window.removeEventListener(EVENTS.PIANO_KEY_DOWN, onNoteOn);
      window.removeEventListener(EVENTS.PIANO_KEY_UP, onNoteOff);
    };
  }, [constructedNote]);

  return <button className={`sk-octave-lower-row${isActive ? ' sk-key-active' : ''}`}
    onPointerDown={() => { setPianoPointerDown(true); emitKeyDown(constructedNote); }}
    onPointerUp={() => { setPianoPointerDown(false); emitKeyUp(constructedNote); }}
    onPointerLeave={() => { emitKeyUp(constructedNote); }}
    onPointerEnter={() => { if (isPianoPointerDown()) emitKeyDown(constructedNote); }}
  >
    <p>{constructedNote}</p>
    <p>{japaneseCharacter}</p>
  </button>


}